import { INicheFeedbackResponse } from "@/common/api/services/types";
import { metricsBus } from "@/common/buses";

type TGetFeedback = {
  gif: string;
  states: INicheFeedbackResponse[];
};

export const getFeedback = ({ gif, states }: TGetFeedback) => {
  for (const state of states) {
    if (state.gif === gif) {
      return state;
    }
  }

  return {
    gif,
    upvotes: 0,
    downvotes: 0,
    state: null
  } as INicheFeedbackResponse;
};

export const sendVoteMetric = (previousAction: string | null, state: string) => {
  switch (previousAction) {
    case null:
      if (state === "up") {
        metricsBus.emit("voteUpAddClicked");
      } else if (state === "down") {
        metricsBus.emit("voteDownAddClicked");
      }
      break;

    case "up":
      if (state === "up") {
        metricsBus.emit("voteUpRemoveClicked");
      } else if (state === "down") {
        metricsBus.emit("voteDownAddClicked");
      }
      break;

    case "down":
      if (state === "down") {
        metricsBus.emit("voteDownRemoveClicked");
      } else if (state === "up") {
        metricsBus.emit("voteUpAddClicked");
      }
      break;
    default:
  }
};
